<template>
  <v-app-bar color="white" min-width="70px" class="shadow-navbar" fixed app>
    <v-list-item-action v-if="!drawer">
      <v-btn icon @click="updateDrawer()">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-list-item-action>
    <v-spacer></v-spacer>

    <!-- Authenticated -->
    <template v-if="authenticated">
      <div class="text-center mr-4" v-if="user_notifs">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-badge v-on="on">
              <template v-slot:badge v-on="on">{{ user_notifs.length }}</template>
              <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
          </template>

          <v-list v-for="(notif, index) in user_notifs" :key="notif.id">
            <v-list-item @click="updateNotif(notif.id, index)">
              <!-- <v-list-item-title>{{ notif.data.title }}</v-list-item-title> -->
              <span>{{ notif.data.title }}</span>
            </v-list-item>
          </v-list>
        </v-menu>

      </div>

      <div class="text-center ml-4">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <div flat class="transparent" v-on="on">
              <v-list v-on="on">
                <v-list-item>
                  <v-list-item-avatar v-if="avatar">
                    <v-img :src="avatar"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content v-if="user">
                    <v-list-item-title v-html="user.username"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </template>
          <v-list>
            <v-list-item prepend-icon="mdi-power">
              <v-btn text @click.prevent="profile">Profile</v-btn>
            </v-list-item>

            <v-list-item prepend-icon="mdi-power">
              <v-btn text @click.prevent="logout">{{ $t('logout') }}</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <!-- <v-btn text :to="{ name: 'settings.profile' }">{{ user.username }}</v-btn> -->
    </template>

    <!-- Guest -->
    <!-- <template v-else>
      <v-btn text :to="{ name: 'login' }">{{ $t('login') }}</v-btn>
    </template> -->
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import * as md5 from 'md5';

export default {
  props: {
    drawer: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    appName: window.config.appName,
  }),

  computed: {
    avatar() {
      if (this.user) {
        if (this.user.avatar_url) {
          return this.user.avatar_url
        } else {
          return `https://www.gravatar.com/avatar/${md5(this.user.email.trim().toLowerCase())}?s=32&d=identicon&r=g`
        }
      }
      console.log("User logged ", this.user);
    },
    user_notifs() {
      if (this.user) {
        let liste = this.user.notifs;
        return liste;
      }
    },
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck'
    })
  },

  methods: {
    updateDrawer() {
      const newdrawer = !this.drawer;
      this.$emit('updateDrawerApp', newdrawer);
    },
    async logout() {

      // Log out the user.
      await this.$store.dispatch('logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    },

    async profile() {
      this.$router.push({ name: 'settings.profile' })
    },

    async updateNotif(value, index) {
      this.$store.dispatch('updateEventNotif', value);
      this.user_notifs.splice(index, 1);
    }
  }
}
</script>

<style >
.toolbar__title .router-link-active {
  text-decoration: none;
}

.v-list-item__avatar:first-child {
  margin-right: 10px;
}

.v-list {
  padding: 0;
}

.v-badge__badge {
  align-items: center;
  border-radius: 11px;
  color: #fff;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 14px;
  height: 22px;
  justify-content: center;
  line-height: normal;
  min-width: 22px;
  padding: 0 4px;
  position: absolute;
  right: -9px;
  top: -14px;
  transition: .3s cubic-bezier(.25, .8, .5, 1);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ToolBar.vue